import React from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import user2 from "../../image/user2.png";
import { useLessonContext } from "@/contexts/lesson-context";
import { useNavigate } from "react-router-dom";

export const FreeTrialTutorsModal = ({
  visible,
  onClose,
  teachers = [],
}: {
  visible: boolean;
  onClose: any;
  teachers: any;
}) => {
  const { updateValues, values } = useLessonContext();

  const navigate = useNavigate();

  return createPortal(
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={onClose}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.45)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              zIndex: 1000,
            }}
          >
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 25,
              }}
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: 500,
                background: "#fff",
                borderTopLeftRadius: 28,
                borderTopRightRadius: 28,
                padding: 24,
                maxHeight: "75%",
                overflowY: "auto",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  marginBottom: 20,
                  color: "#169FED",
                  fontWeight: 600,
                }}
              >
                Trial Lessons
              </h2>

              <motion.div
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={{
                  hidden: {},
                  visible: {
                    transition: {
                      staggerChildren: 0.08,
                    },
                  },
                }}
              >
                {teachers.length < 1 ? (
                  <h4
                    style={{
                      color: "#777",
                    }}
                  >
                    Something went wrong
                  </h4>
                ) : (
                  teachers.map((teacher: any, index: any) => (
                    <motion.div
                      key={teacher.id || index}
                      variants={{
                        hidden: { opacity: 0, y: 30 },
                        visible: { opacity: 1, y: 0 },
                      }}
                      transition={{ duration: 0.35 }}
                      onClick={() => {
                        onClose();

                        updateValues({
                          ...values,
                          marchantId: teacher.id,
                          teacher: {
                            firstName: teacher.first_name,
                            lastName: teacher.last_name,
                            dpUrl: teacher.dpUrl,
                          },
                        });
                        navigate(`/teachers/${teacher.id}?booking=true`);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: 16,
                        borderRadius: 16,
                        marginBottom: 14,
                        background: "#fff",
                        cursor: "pointer",
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
                      }}
                      whileHover={{
                        scale: 1.02,
                      }}
                      whileTap={{
                        scale: 0.98,
                      }}
                    >
                      <img
                        src={teacher.dpUrl ?? user2}
                        alt="avatar"
                        style={{
                          width: 55,
                          height: 55,
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginRight: 15,
                        }}
                      />

                      <div>
                        <div style={{ fontWeight: 600 }}>
                          {teacher.first_name} {teacher.last_name}
                        </div>
                        <div
                          style={{
                            color: "#777",
                            marginTop: 4,
                            fontSize: 14,
                          }}
                        >
                          {teacher.teachingType}
                        </div>
                      </div>
                    </motion.div>
                  ))
                )}
              </motion.div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body,
  );
};
